<template>
  <!-- 论文列表 -->
  <div>
    <!-- <p class="lv-total">找到{{ total }}条结果</p> -->
    <van-list
      v-model="loading"
      :offset="50"
      :finished="finished"
      :error="error"
      :finished-text="List.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="btn">
        <van-dropdown-menu class="mydropdown" active-color="#00982d">
          <van-dropdown-item
            :value="resourceTypeValue.queryValue[0]"
            :options="resourceType"
            @change="resourceTypeChange"
          />
        </van-dropdown-menu>
        <div class="right">找到{{ total }}条结果</div>
      </div>
      <div class="lv-list-box" v-if="loading || List.length > 0">
        <LvItem
          v-for="item in List"
          :key="item.id"
          class="lv-list-item"
          :type="item.type"
          :title="item.title"
          :artSummary="item.artSummary"
          :author="item.authors[0].name"
          :otherAuthor="
            item.authors &&
            Array.isArray(item.authors) &&
            item.authors.length > 1
              ? ',...'
              : ''
          "
          :periodicalName="item.periodical"
          :periodicalTime="
            item.type === 1
              ? `${item.journalsYear}年${item.journalsVolume}月${item.journalsTerm}日`
              : `${item.journalsYear}年第${item.journalsTerm}期`
          "
          @click.native="toDetail(item.id)"
        />
      </div>
      <noneList noneType="search" v-else />
    </van-list>
  </div>
</template>

<script>
import LvItem from "@/views/mobileView/components/listItem/lvItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "Lw",
  components: {
    LvItem,
    noneList,
  },
  data() {
    return {
      Params: {
        pageNo: 0,
        pageSize: 20,
        queryParam: {
          configMap: {
            must: [
              {
                esField: "all",
                queryValue: this.$route.query.paramStr,
              },
              {
                esField: "articleType",
                queryValue: [0],
              },
            ],
          },
          otherQueryParams: {
            platformId: 1,
          },
        },
      },
      List: [],
      total: 0,
      loading: false,
      finished: false,
      error: false,
      resourceType: [
        { text: "全部", value: "all" },
        { text: "期刊论文", value: "0" },
        { text: "会议论文", value: "1" },
      ],
      resourceTypeValue: {
        esField: "type",
        queryValue: ["all"],
      },
    };
  },
  methods: {
    // 触底加载
    onLoad() {
      this.Params.pageNo += 1;
      this.getSearchList();
    },
    // 资源类型
    resourceTypeChange(item) {
      this.resourceTypeValue.queryValue = [item];
      this.Params.pageNo = 1;
      this.getSearchList();
    },
    // 获取论文列表
    async getSearchList() {
      if (this.resourceTypeValue.queryValue[0] !== "all") {
        this.Params.queryParam.configMap.must[2] = this.resourceTypeValue;
      } else {
        this.Params.queryParam.configMap.must.splice(2, 1);
      }
      const res = await this.$apis.searchServe.getEsList(this.Params);
      if (res.resultCode == 200) {
        if (res.data.total > 20 && res.data.pageNum > 1) {
          this.List.push(...res.data.list);
        } else {
          this.List = res.data.list;
        }
        this.total = +res.data.total;
        this.finished = res.data.list.length < 20;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    // 论文跳转详情
    toDetail(id) {
      this.$router.push({
        name: "thesisDetail",
        query: {
          id: id,
          type: 0,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.lv-total {
  text-align: center;
  font-size: 13px;
  color: #999999;
  line-height: 19px;
}
.btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .right {
    line-height: 30px;
    font-size: 13px;
    color: #999999;
  }
}
.mydropdown {
  flex: none;

  &::v-deep .van-dropdown-menu__bar {
    padding-left: 10px;
    padding-right: 25px;
    height: 30px;
    border-radius: 15px;
    box-shadow: none !important;
    .van-dropdown-menu__item {
      .van-dropdown-menu__title {
        padding: 0;
        .van-ellipsis {
          font-size: 14px;
          color: #333333;
        }
        &::after {
          right: -12px;
          border-color: transparent transparent currentColor currentColor !important;
        }
      }
    }
  }
  &::v-deep .van-dropdown-menu__bar--opened {
    .van-dropdown-menu__item {
      .van-dropdown-menu__title {
        .van-ellipsis {
          color: #397bf9;
        }
        &::after {
          color: #397bf9;
        }
      }
    }
  }
  &::v-deep .van-dropdown-item__option--active {
    .van-cell__title {
      span {
        color: #397bf9;
      }
    }
    .van-cell__value {
      .van-icon {
        &::before {
          color: #397bf9;
        }
      }
    }
  }
}
.lv-list-box {
  margin-top: 15px;
  padding: 0 12px;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;

  .lv-list-item {
    border-bottom: 1px solid #eee;
  }
}
</style>
